import type { IconCategoriesDictionary } from '@builder4/shared/icons/manager';

/**
 * Filters categories to only include icons that exist in the loaded dictionary.
 */
export const buildCategoriesFromManager = (
  categories: IconCategoriesDictionary,
  availableNames: Set<string>,
): IconCategoriesDictionary => {
  const result: IconCategoriesDictionary = {};

  for (const [label, icons] of Object.entries(categories)) {
    const filtered = icons.filter((name) => availableNames.has(name));
    if (filtered.length > 0) {
      result[label] = filtered;
    }
  }

  return result;
};
